import { Routes } from '@angular/router';
import { Activate_userComponent } from './activate_user/activate_user.component';
import { Change_passwordComponent } from './change_password/change_password.component';
import { CommonlayoutComponent } from './common-layout/common-layout.component';
import { Forgot_passwordComponent } from './forgot_password/forgot_password.component';
import { AuthGuard } from './guards/auth.guard';
import { PWDAuthGuard } from './guards/pwd_auth.guard';
import { LoginComponent } from './login/login.component';
import { Add_userComponent } from './ndm/management/manage_user/add_user/add_user.component';
import { Register_userComponent } from './ndm/management/manage_user/register_user/register_user.component';
import { Reset_passwordComponent } from './ndm/reset_password/reset_password.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'index',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '',
    component: CommonlayoutComponent,
    children: [
      { path: 'change-password', component: Change_passwordComponent, canActivate: [PWDAuthGuard] },
      {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
      },
      {
        path: 'data-entry',
        loadChildren: () => import('./ndm/data_entry/data_entry.module').then(m => m.DataEntryModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'view-data',
        loadChildren: () => import('./ndm/view_data/view_data.module').then(m => m.ViewDataModule),
      },
      {
        path: 'management',
        loadChildren: () => import('./ndm/management/management.module').then(m => m.ManagementModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'about',
        loadChildren: () => import('./ndm/about/about.module').then(m => m.AboutModule),
      },
      {
        path: 'help',
        loadChildren: () => import('./ndm/help/help.module').then(m => m.HelpModule),
      },
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: 'reset-password/:token', component: Reset_passwordComponent },
  { path: 'forgot-password', component: Forgot_passwordComponent },
  { path: 'create-user', component: Register_userComponent },
  { path: 'activate-user', component: Activate_userComponent },
];
